import { actionCopyDe } from "./actionCopy";

export const ratingsListCopyDe = {
    addActivityPlaceholder: (current: number, max: number) => `Aktivität ${current}/${max} hinzufügen`,
    add: actionCopyDe.add,
    emptyHint: "Fügen Sie oben Aktivitäten hinzu, um Ihre Schwierigkeit zu bewerten",
    noDifficulty: "Keine Schwierigkeit",
    unableToDo: "Nicht möglich",
    loading: "Aktivitäten werden geladen...",
    loadError: "Ihre Aktivitätsliste konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
    noBaselineActivities:
        "Für diesen Tracker wurden keine Ausgangsaktivitäten gefunden. Schließen Sie zuerst den ersten Eintrag ab, bevor Sie eine Folgeerhebung absenden.",
    followUpHint:
        "Bewerten Sie Ihre aktuelle Schwierigkeit bei jeder Aktivität, die Sie beim Ausgangswert gewählt haben.",
};
